import React from 'react';
import TaskSectionPage from '../components/TaskSectionPage';

const Grammar: React.FC = () => {
  return (
    <TaskSectionPage
      section="grammar"
      title="Grammar"
      description="Master English grammar with interactive exercises and clear explanations."
    />
  );
};

export default Grammar;